<template>
  <div>
    <div :class="logisticContainerClass">
      <div class="panel-container">
        <!-- Header -->
        <div class="header-section">
          <div class="product-info">
            <h2>{{ groupOrder.orderName }}</h2>
            <div class="meta-row">
              <span><b>Data utw.:</b> {{ groupOrder.orderCreationDate }}</span>
              <span><b>Dostawca:</b> {{ groupOrder.centralSupplierGuid }}</span>
            </div>
          </div>
        </div>

        <div class="actions-section" style="margin-top:4px;">
          <div class="col-sm-6">
            <button
              class="d-none d-sm-inline-block btn btn-sm btn-outline-primary shadow-sm"
              style="margin-right: 4px;"
              @click="openImportStage"
            >
              <i class="fas fa-file-import me-1"></i>
              Importuj wycenę hurtowni
            </button>

            <button
              class="d-none d-sm-inline-block btn btn-sm btn-outline-info shadow-sm"
              style="margin-right: 4px;"
              @click="$emit('openDiscountsModal')"
            >
              <i class="fas fa-tags me-1"></i>
              Rabaty
            </button>

            <button
              class="d-none d-sm-inline-block btn btn-sm btn-info shadow-sm"
              style="margin-right: 4px;"
              @click="$emit('onExportToExcel')"
            >
              <i class="fas fa-file-excel me-1"></i>
              Eksportuj do excel
            </button>
          </div>

          <div class="col-sm-6 justify-end" style="padding-top:4px;">
<!--            <span style="margin-right: 8px; font-size: 13px; line-height: 30px;"><b>Hurtownia do realizacji:</b></span>-->
<!--            <select-->
<!--              class="form-select form-select-sm"-->
<!--              style="width: auto; display: inline-block; margin-right: 8px;"-->
<!--              :value="selectedWholesaler"-->
<!--              @change="$emit('update:selectedWholesaler', $event.target.value)"-->
<!--            >-->
<!--              <option value="">&#45;&#45; wybierz &#45;&#45;</option>-->
<!--              <option v-for="w in wholesalers" :key="w.key" :value="w.key">{{ w.name }}</option>-->
<!--            </select>-->

<!--            <button-->
<!--              class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"-->
<!--              :disabled="!selectedWholesaler"-->
<!--              @click="onSendToRealisation"-->
<!--            >-->
<!--              <i class="mdi mdi-truck-fast me-1"></i>-->
<!--              Wyślij do realizacji-->
<!--            </button>-->

            <div v-if="groupOrder.orderStatus === 'PRICING_IN_PROGRESS'">

              <button class="alert alert-success" role="alert" style="padding: 4px;margin: unset;"
                      @click="sendOrderToWholesalersPricing()">
                <i class="fas fa-check-circle"></i> Wysłane do wyceny (Wyślij ponownie)
              </button>


            </div>
            <div v-else>

              <button

                  class="d-none d-sm-inline-block btn btn-sm btn-outline-success shadow-sm justify-end"
                  style="margin-right: 4px;"
                  @click="sendOrderToWholesalersPricing()"

              >
                <i class="mdi mdi-truck-fast ms-1"/>
                Wyślij do wyceny hurtowni
              </button>

            </div>

            <div v-if="!groupOrder.publishedAt">

              <button

                  class="d-none d-sm-inline-block btn btn-sm btn-outline-success shadow-sm justify-end"
                  style="margin-left: 4px;"
                  @click="onSendToRealisation()"

              >
                <i class="mdi mdi-truck-fast ms-1"/>
                Wyślij do realizacji
              </button>

            </div>
            <div v-else>

              <div class="alert alert-success" role="alert" style="padding: 4px;margin-left: 4px;">
                <i class="fas fa-check-circle"></i> Wysłane do realizacji
              </div>


            </div>





          </div>
        </div>
      </div>
    </div>

    <!-- Stage 1: Select wholesalers via SupplierListModal -->
    <SupplierListModal
      v-if="showSupplierModal"
      v-model:showModal="showSupplierModal"
      :multiselect="true"
      title="Importuj wycenę hurtowni — krok 1: Wybierz hurtownie"
      okTitle="Dalej"
      @onApply="handleWholesalersSelected"
      @onClose="showSupplierModal = false"
      :showMassActions="false"
      :showAddButton="false"
      :showCheckboxColumn="true"
      :visibleColumnsFilter="['id', 'centralId', 'nip', 'name']"
    />

    <!-- Stage 2: Choose import source -->
    <b-modal
      v-model="showImportSourceModal"
      id="import-wholesaler-source-modal"
      title="Importuj wycenę hurtowni — krok 2: Źródło danych"
      title-class="font-18"
      size="lg"
      style="z-index:100010!important;"
      hide-footer
    >
      <div>
        <div class="mb-3">
          <label class="form-label fw-bold">Wybrane hurtownie:</label>
          <ul class="list-group list-group-flush mb-0">
            <li
              v-for="w in selectedImportWholesalers"
              :key="w.guid || w.id"
              class="list-group-item py-1 px-2 d-flex align-items-center gap-2"
            >
              <i class="fas fa-building text-primary"></i>
              <span>{{ w.name }}</span>
              <small v-if="w.id" class="text-muted ms-1">({{ w.id }})</small>
            </li>
          </ul>
        </div>

        <div class="form-group mb-3">
          <label class="form-label fw-bold">Źródło danych wyceny:</label>
          <div class="form-check mt-2">
            <input
              class="form-check-input"
              type="radio"
              id="sourceOffer"
              value="OFFER"
              v-model="importSource"
            />
            <label class="form-check-label" for="sourceOffer">
              Oferty systemu Kamsoft
            </label>
          </div>
          <div class="form-check mt-2">
            <input
              class="form-check-input"
              type="radio"
              id="sourceExcel"
              value="EXCEL"
              v-model="importSource"
            />
            <label class="form-check-label" for="sourceExcel">
              Importuj z pliku Excel
            </label>
          </div>
        </div>

        <div class="d-flex justify-content-between mt-3">
          <button class="btn btn-secondary btn-sm" @click="backToStage1">
            <i class="fas fa-arrow-left me-1"></i> Wstecz
          </button>
          <div class="d-flex gap-2">
            <button class="btn btn-secondary btn-sm" @click="closeAll">Anuluj</button>
            <button
              class="btn btn-primary btn-sm"
              :disabled="!importSource"
              @click="confirmImport"
            >
              <i class="fas fa-file-import me-1"></i>
              {{ importSource === 'EXCEL' ? 'Otwórz formularz importu' : 'Importuj' }}
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Excel import wrapper -->
    <PackageOrderWholesalerPricingImportWrapper
      v-if="showExcelImportWrapper"
      ref="pricingExcelImportWrapper"
      :orderGroupGuid="groupOrder.groupGuid"
      :selectedWholesalers="selectedImportWholesalers"
      @onImportSuccess="onExcelImportSuccess"
      @onClose="onExcelImportClose"
    />
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue-next';
import { useLayoutStore } from '@/state/pinia/layout';
import SupplierListModal from '@/views/DrugstoreCommonManager/SupplierListModal.vue';
import PackageOrderWholesalerPricingImportWrapper from '@/views/PackagesManager/PackageOrderWholesalerPricingImportWrapper.vue';
import Swal from "sweetalert2";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";

export default {
  name: 'PackageOrderGeneratorPricingDetailsSection',
  components: { BModal, SupplierListModal, PackageOrderWholesalerPricingImportWrapper },
  props: {
    groupOrder: { type: Object, required: true },
    isEmpty: { type: Boolean, required: true },
    orderTableHeaders: { type: Array, required: true },
    selectedWholesaler: { type: String, default: null },
    wholesalers: { type: Array, default: () => [] },
  },
  emits: [
    'openDiscountsModal',
    'onImportWholesalerPricing',
    'onExportToExcel',
    'onSendToRealisation',
    'update:selectedWholesaler',
  ],
  data() {
    return {
      showSupplierModal: false,
      showImportSourceModal: false,
      showExcelImportWrapper: false,
      selectedImportWholesalers: [],
      importSource: 'OFFER',
    };
  },
  computed: {
    layoutStore() {
      return useLayoutStore();
    },
    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      },
    },
    logisticContainerClass() {
      if (this.layout === 'horizontal') {
        return 'logistic-container';
      } else {
        return 'logistic-container-vertical';
      }
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    packagesModule() {
      return usePackagesManagerModule();
    },
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    getDiscountsFields() {
      return this.orderTableHeaders
        .filter(header => header.key.startsWith('packageDiscount_'))
        .map(header => ({
          key: header.key,
          label: header.text,
          required: false,
          type: header.type === 'number' ? 'number' : 'string',
        }));
    },
  },
  methods: {
    openImportStage() {
      this.selectedImportWholesalers = [];
      this.importSource = 'OFFER';
      this.showSupplierModal = true;
    },
    handleWholesalersSelected(selection) {
      this.selectedImportWholesalers = Array.isArray(selection) ? selection : (selection ? [selection] : []);
      if (this.selectedImportWholesalers.length === 0) return;
      this.showSupplierModal = false;
      this.showImportSourceModal = true;
    },
    backToStage1() {
      this.showImportSourceModal = false;
      this.showSupplierModal = true;
    },
    closeAll() {
      this.showSupplierModal = false;
      this.showImportSourceModal = false;
      this.showExcelImportWrapper = false;
    },
    confirmImport() {
      if (this.importSource === 'EXCEL') {
        this.showImportSourceModal = false;
        this.showExcelImportWrapper = true;
        this.$nextTick(() => {
          if (this.$refs.pricingExcelImportWrapper) {
            this.$refs.pricingExcelImportWrapper.open();
          }
        });
      } else {
        this.showImportSourceModal = false;
        this.$emit('onImportWholesalerPricing', {
          wholesalers: this.selectedImportWholesalers,
          source: this.importSource,
        });
      }
    },
    onExcelImportSuccess() {
      this.showExcelImportWrapper = false;
      this.$emit('onImportWholesalerPricing', {
        wholesalers: this.selectedImportWholesalers,
        source: 'EXCEL',
      });
    },
    onExcelImportClose() {
      this.showExcelImportWrapper = false;
    },
    async onSendToRealisation() {
      if (!this.selectedWholesaler) return;


      if (this.isEmpty) {
        Swal.fire({
          title: "Nie można wysłać",
          text: "Zamówienie nie zawiera żadnych produktów. Uzupełnij zamówienie przed wysyłką do realizacji.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }

      if (this.groupOrder.doCreateProspect && !this.groupOrder.prospectCloseDate) {
        Swal.fire({
          title: "Nie można wysłać",
          text: "Istnieje otwarty prospekt do tego zamówienia.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }

      const isOk = await this.checkItemsBelowLogisticMinPerOrder()
      if (!isOk) return;



      this.$emit('onSendToRealisation', { wholesalerKey: this.selectedWholesaler });
    },

    async sendOrderToWholesalersPricing() {
      if (this.isEmpty) {
        Swal.fire({
          title: "Nie można wysłać",
          text: "Zamówienie nie zawiera żadnych produktów. Uzupełnij zamówienie przed wysyłką do wyceny.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }

      if (this.groupOrder.doCreateProspect && !this.groupOrder.prospectCloseDate) {
        Swal.fire({
          title: "Nie można wysłać",
          text: "Istnieje otwarty prospekt do tego zamówienia.",
          icon: "warning",
          confirmButtonText: "OK"
        });
        return;
      }

      const isOk = await this.checkItemsBelowLogisticMinPerOrder()
      if (!isOk) return;

      this.$emit('onOrderSentToPricing', true);
    },

    async checkItemsBelowLogisticMinPerOrder() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      var response = await this.packagesModule.httpGetItemsBelowLogisticMinPerOrder({orderGroupGuid: this.groupOrder.groupGuid});
      this.lazyloaderModule.setDisplayLazyLoader(false);
      const itemsBelowMinPerOrder = response.data.payload;
      if (itemsBelowMinPerOrder && itemsBelowMinPerOrder.length > 0) {
        let message = "Nie można wysłać do realizacji. Następujące pozycje mają ilość poniżej minimalnej logistycznej na zamówienie:\n\n";
        itemsBelowMinPerOrder.forEach(item => {
          message += `-${item.listIndex}. ${item.name} (Ilość: ${item.amount}, Minimalna ilość logistyczna: ${item.logisticMinAmountPerOrder})\n`;
        });

        Swal.fire({
          title: "Pozycje poniżej minimalnej ilości logistycznej",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "OK",
          input: "textarea",
          inputPlaceholder: "Brak informacji",
          inputValue: message,
          customClass: {
            width: "850px!important",
            container: "swal-highest"
          },
          inputAttributes: {
            disabled: true
          }
        });

        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.logistic-container {
  font-family: "Segoe UI", Tahoma, sans-serif;
  font-size: 13px;
  color: #2b2b2b;
  transition: all 0.2s ease;
  position: fixed;
  top: 112px;
  left: 0;
  width: 100vw;
  z-index: 99;
  background: #f3f2f1;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.logistic-container-vertical {
  font-family: "Segoe UI", Tahoma, sans-serif;
  font-size: 13px;
  color: #2b2b2b;
  transition: all 0.2s ease;
  position: unset;
  top: 112px;
  left: 0;
  width: 100%;
  z-index: 99;
  background: #f3f2f1;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.show-logistic-container-btn {
  width: 100%;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.center-show {
  text-align: center;
}

.panel-container {
  background: #f3f2f1;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 6px;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #c8c6c4;
  padding-bottom: 8px;
}

.actions-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #c8c6c4;
  margin-bottom: 2px;
}

.product-info h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #0078D4;
}

.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 12.5px;
  color: #3b3a39;
}

.drugstore-info h3 {
  font-size: 15px;
  font-weight: 600;
  color: #201f1e;
  margin-bottom: 4px;
}

.data-grid-compact {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: 16px;
}

.data-section {
  background: #ffffff;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  padding: 12px;
}

.section-title {
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 13.5px;
  color: #005A9E;
}

.grid-2col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 12px;
}

.grid-2col div {
  display: flex;
  justify-content: space-between;
  padding: 4px 8px;
  background: #f9f9f9;
  border: 1px solid #e1dfdd;
  border-radius: 3px;
}

.grid-2col span {
  font-weight: 500;
  color: #605e5c;
}

.grid-2col b {
  color: #0078D4;
  font-weight: 600;
}

.chart-box {
  margin-top: 10px;
  background: #f5f5f5;
  border: 1px solid #e1dfdd;
  border-radius: 3px;
  padding: 6px;
}

.product-data-placeholder {
  background: #f3f2f1;
  border: 1px dashed #c8c6c4;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
  font-style: italic;
  font-size: 13px;
}

.justify-end {
  justify-content: flex-end !important;
  display: flex;
}
</style>
